import React from "react";
import Slider from "react-slick";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { Item } from "../../../types/Item";
import auctionService from "../../../services/auctionService";
import { formatPrice } from "../../../utils/formatters";

interface AuctionCardProps {
  item: Item;
}

const AuctionCard: React.FC<AuctionCardProps> = ({ item }) => {
  const images =
    item.images && item.images.length > 0
      ? item.images
      : ["/default-auction-image.jpg"];

  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const formatEndTime = (endTime: string | Date) => {
    const date = new Date(endTime);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <Card
      component={Link}
      to={`/items/${item.id}`}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        textDecoration: "none",
        "&:hover": {
          transform: "scale(1.02)",
          transition: "transform 0.2s ease-in-out",
        },
      }}
    >
      <Box sx={{ width: "100%", height: 200, background: "#f5f5f5" }}>
        <Slider {...settings}>
          {images.map((img: string, idx: number) => (
            <img
              key={idx}
              src={auctionService.getImageUrl(img)}
              alt={`${item.title} ${idx + 1}`}
              style={{ width: "100%", height: 200, objectFit: "cover" }}
            />
          ))}
        </Slider>
      </Box>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography gutterBottom variant="h6" component="div" noWrap>
          {item.title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {item.description}
        </Typography>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" color="primary">
            {formatPrice(item.current_price ?? item.starting_price ?? 0)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Ends {formatEndTime(item.end_time)}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AuctionCard;
